import React from 'react';

import banner1 from 'assets/can-store/modernTemplate/banner1.png';
import banner2 from 'assets/can-store/modernTemplate/banner2.jpg';
import banner3 from 'assets/can-store/modernTemplate/banner3.jpg';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

function ModernBannerPromo(): JSX.Element {
	return (
		<ImageList variant="quilted" cols={3} rowHeight={200} gap={10}>
			<ImageListItem cols={2} rows={2}>
				<img src={banner1} alt="banner1" loading="lazy" style={{ cursor: 'pointer' }} />
				<Box
					component="div"
					sx={{
						position: 'absolute',
						top: '50%',
						left: '30%',
						transform: 'translate(-50%, -50%)',
					}}
				>
					<Typography
						variant="h3"
						gutterBottom
						sx={{ color: 'var(--csmd-cl-text-secondary)', maxWidth: '27.5rem' }}
					>
						Create Your Own Stuffed Animal in Red Deer
					</Typography>
					<Button variant="contained">SHOW NOW</Button>
				</Box>
			</ImageListItem>
			<ImageListItem>
				<img src={banner2} alt="banner2" loading="lazy" style={{ cursor: 'pointer' }} />
				<Box
					component="div"
					sx={{
						position: 'absolute',
						top: '50%',
						left: '25%',
						transform: 'translate(-50%, -50%)',
					}}
				>
					<Typography
						variant="h4"
						gutterBottom
						sx={{ color: 'var(--csmd-cl-text-secondary)', maxWidth: '20rem' }}
					>
						Up to 50%
					</Typography>
					<Button variant="contained">SHOW NOW</Button>
				</Box>
			</ImageListItem>
			<ImageListItem>
				<img src={banner3} alt="banner3" loading="lazy" style={{ cursor: 'pointer' }} />
				<Box
					component="div"
					sx={{
						position: 'absolute',
						top: '50%',
						left: '65%',
						transform: 'translate(-50%, -50%)',
					}}
				>
					<Typography
						variant="h4"
						gutterBottom
						sx={{ color: 'var(--csmd-cl-text-secondary)', maxWidth: '10rem' }}
					>
						Thanksgiving Promotion
					</Typography>
					<Button variant="contained">SHOW NOW</Button>
				</Box>
			</ImageListItem>
		</ImageList>
	);
}

export default ModernBannerPromo;
